// Raw Formik calculator state. Yes/No answers are tri-state booleans (`true` = Ja, `false` = Nein,
// `null` = not yet answered); amount fields are numeric (FormikDecimalTextField binds them as
// `number | null`, `null` = empty).
export interface SpousalMaintenanceFormValues {
  isMarried: boolean | null;
  spouseIncome: number | null;
  hasOwnIncome: boolean | null;
  ownIncome: number | null;
  livingTogether: boolean | null;
  housingCosts: number | null;
  children: number | null;
}

export const SPOUSAL_MAINTENANCE_EMPTY_VALUES: SpousalMaintenanceFormValues = {
  isMarried: null,
  spouseIncome: null,
  hasOwnIncome: null,
  ownIncome: null,
  livingTogether: null,
  housingCosts: null,
  children: null,
};

// Which questions are currently revealed. The calculator asks them one at a time: a question only
// appears once the previous one has been answered.
export interface SpousalMaintenanceFieldVisibility {
  notMarried: boolean;
  showSpouseIncome: boolean;
  showHasOwnIncome: boolean;
  showOwnIncome: boolean;
  showLivingTogether: boolean;
  showHousingCosts: boolean;
  showChildren: boolean;
}

// Parsed form answers fed to the (front-end) calculation. Own income of 0 means "no own income"
// (the Yes/No answer maps "Nein" → 0); the calculator selects the 33%- vs 40%-rule from this.
export interface SpousalMaintenanceInput {
  spouseIncome: number;
  ownIncome: number;
  livingTogether: boolean;
  housingCosts: number;
  children: number;
}

// Calculation result + breakdown produced by the front-end calculator. The UI and the summary
// builder depend only on this type.
export interface SpousalMaintenanceCalculation {
  claim: number;
  effectivePercent: number;
  spouseFreeIncome: number;
  housingDeducted: number;
  jointIncome: number;
  jointFreeIncome: number;
  fortyRuleAmount: number;
  thirdRuleAmount: number;
  cappedAtThirdRule: boolean;
  ownIncomeExceedsForty: boolean;
}

// Rendered result text produced by buildResultText (see SpousalMaintenance.utils).
export interface ResultText {
  // Short red headline (the claim amount, or the "exceeds 40%" message).
  headline: string;
  // First-person legal summary, or null when there is no claim to explain (exceeds-40% case).
  summary: string | null;
}
